module.exports = __webpack_public_path__ + "static/media/obeal-dl-violet.80503a83.png";